import { usePathname, useSearchParams } from 'next/navigation'
import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'

const PreviousPathContext = createContext<string | null>(null)

export const PreviousPathProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [previousPath, setPreviousPath] = useState<string | null>(null)
  const lastPath = useRef<string | null>(null)

  const pathname = usePathname()
  const searchParams = useSearchParams()
  const fullPath = useMemo(
    () =>
      searchParams.toString()
        ? `${pathname}?${searchParams.toString()}`
        : pathname,
    [pathname, searchParams]
  )

  useEffect(() => {
    setPreviousPath(lastPath.current)
    lastPath.current = fullPath
  }, [fullPath])

  return (
    <PreviousPathContext.Provider value={previousPath}>
      {children}
    </PreviousPathContext.Provider>
  )
}

export const usePreviousPath = () => useContext(PreviousPathContext)
